import axios from 'axios';
import importInterceptors from '@/utils/importInterceptors';
import { client } from 'laravel-precognition-vue';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

importInterceptors();

client.use(window.axios);
